
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PqtMeasurementSpecification, PqtMeasurementValueType } from '../../backend/backendapi';
import PqtMeasurementSpecificationEditor from './PqtMeasurementSpecificationEditor';

@Component({
  components: {
    PqtMeasurementSpecificationEditor,
  },
})
export default class PqtMeasurementSpecificationEditModal extends Vue {
  specification: PqtMeasurementSpecification | null = null;

  get canSave(): boolean {
    return !!this.specification?.name
        && (
            (this.specification.type === PqtMeasurementValueType.Float && this.specification?.lowerBound !== undefined)
            || this.specification.type === PqtMeasurementValueType.String
        )
        && this.specification?.nominalValue !== undefined
        && (
            (this.specification.type === PqtMeasurementValueType.Float && this.specification?.upperBound !== undefined)
            || this.specification.type === PqtMeasurementValueType.String
        );
  }

  public open(specification: PqtMeasurementSpecification): void {
    this.specification = PqtMeasurementSpecification.fromJS(specification); //edit copy
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }
}
